import React from "react";
import { cn } from "@sys42/utils";

import * as styles from "./styles.module.css";

export function EntityCardList({ children, className, ...props }) {
  return (
    <div className={cn(styles.entityCardList, className)} {...props}>
      {children}
    </div>
  );
}
